// In ~js/utils/variant.js
export function postAddToCart(items, callback) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
      })),
    }),
  })
    .then(async (response) => await response.json())
    .then(async () => {
      if (callback) callback();
      await window.CartDrawer?.fetch?.();
      window.CartDrawer?.show?.(false);
    })
    .catch((error) => console.error('Error adding to cart:', error));
}
